module.exports = "https://web-assets-production.autolist.com/_next/static/images/teams-9582e231baa428f6bf71e50fe11029f5.jpg";